import request from '@/utils/request'

/**
 * 根据食堂获取摄像头坐标(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraByDeptListGet(data) {
  return request({
    type: 'device',
    url: 'camera/by/dept/list/get',
    method: 'post',
    data
  })
}

/**
 * 摄像头可见状态编辑(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraConfigAppvisibleUpdate(data) {
  return request({
    type: 'device',
    url: 'camera/config/appvisible/update',
    method: 'post',
    data
  })
}

/**
 * 获取当前登录人员的摄像头列表(后厨直播)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraConfigByAccountListGet(data) {
  return request({
    type: 'device',
    url: 'camera/config/by/account/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取当前学校的摄像头列表(后厨直播)(微信公众号)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraConfigByOrgListGet(data) {
  return request({
    type: 'device',
    url: 'camera/config/by/org/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取当前登录人员有权限的摄像头列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraConfigByRoleListGet(data) {
  return request({
    type: 'device',
    url: 'camera/config/by/role/list/get',
    method: 'post',
    data
  })
}

/**
 * 添加摄像头(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraConfigInfoAdd(data) {
  return request({
    type: 'device',
    url: 'camera/config/info/add',
    method: 'post',
    data
  })
}

/**
 * 摄像头删除(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraConfigInfoDelete(data) {
  return request({
    type: 'device',
    url: 'camera/config/info/delete',
    method: 'post',
    data
  })
}

/**
 * 获取摄像头详情(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraConfigInfoGet(data) {
  return request({
    type: 'device',
    url: 'camera/config/info/get',
    method: 'post',
    data
  })
}

/**
 * 获取摄像头详情(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraConfigInfoGetByNvrip(data) {
  return request({
    type: 'device',
    url: 'camera/config/info/get/by/nvrip',
    method: 'post',
    data
  })
}

/**
 * 摄像头编辑(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraConfigInfoUpdate(data) {
  return request({
    type: 'device',
    url: 'camera/config/info/update',
    method: 'post',
    data
  })
}

/**
 * 获取摄像头配置列表(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraConfigListGet(data) {
  return request({
    type: 'device',
    url: 'camera/config/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取当前登录人员所属组织下所有食堂的摄像头列表树(yzw)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraConfigTreeListGet(data) {
  return request({
    type: 'device',
    url: 'camera/config/tree/list/get',
    method: 'post',
    data
  })
}

/**
 * 摄像头-根据食堂、归属类别(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraDeptCategriesList(data) {
  return request({
    type: 'device',
    url: 'camera/dept/categries/list',
    method: 'post',
    data
  })
}

/**
 * 首页获取摄像头列表(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraHomepageListGet(data) {
  return request({
    type: 'device',
    url: 'camera/homepage/list/get',
    method: 'post',
    data
  })
}

/**
 * 摄像头-获取流视频(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraInnerStreamGet(data) {
  return request({
    type: 'device',
    url: 'camera/inner/stream/get',
    method: 'post',
    data
  })
}

/**
 * 联动喇叭（wuzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraLinkageHorn(data) {
  return request({
    type: 'device',
    url: 'camera/linkage/horn',
    method: 'post',
    data
  })
}

/**
 * 获取组织和流媒体客户端的绑定关系(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraLocationListGet(data) {
  return request({
    type: 'device',
    url: 'camera/location/list/get',
    method: 'post',
    data
  })
}

/**
 * 更新组织与区域关联(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraLocationUpdate(data) {
  return request({
    type: 'device',
    url: 'camera/location/update',
    method: 'post',
    data
  })
}

/**
 * 获取摄像头选项列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraOptionListGet(data) {
  return request({
    type: 'device',
    url: 'camera/option/list/get',
    method: 'post',
    data
  })
}

/**
 * 实时人流(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraRealStream(data) {
  return request({
    type: 'device',
    url: 'camera/real/stream',
    method: 'post',
    data
  })
}

/**
 * 摄像头-获取区域的摄像头配置列表(有权限)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraRegionAuthListGet(data) {
  return request({
    type: 'device',
    url: 'camera/region/auth/list/get',
    method: 'post',
    data
  })
}

/**
 * 摄像头-获取区域的摄像头配置列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraRegionListGet(data) {
  return request({
    type: 'device',
    url: 'camera/region/list/get',
    method: 'post',
    data
  })
}

/**
 * 摄像头-根据食堂获取区域摄像头的个数统计(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraRegionNumberList(data) {
  return request({
    type: 'device',
    url: 'camera/region/number/list',
    method: 'post',
    data
  })
}

/**
 * 启用/禁用策略
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraStrategyUpdate(data) {
  return request({
    type: 'device',
    url: 'camera/strategy/update',
    method: 'post',
    data
  })
}

/**
 * 摄像头-获取流视频(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraStreamGet(data) {
  return request({
    type: 'device',
    url: 'camera/stream/get',
    method: 'post',
    data
  })
}

/**
 * 绑定萤石云摄像头-获取流视频(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function cameraYsStreamUrlGet(data) {
  return request({
    type: 'device',
    url: 'camera/ys/stream/url/get',
    method: 'post',
    data
  })
}

/**
 * 人流量-食堂、承包商客流峰值（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function dcPeekDpssGet(data) {
  return request({
    type: 'device',
    url: 'dc/peek/dpss/get',
    method: 'post',
    data
  })
}

/**
 * 人流量-食堂客流峰值(食堂级)（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptPeekDpssGet(data) {
  return request({
    type: 'device',
    url: 'dept/peek/dpss/get',
    method: 'post',
    data
  })
}

/**
 * 人流量-获取时段实时人流量（wzp）(内部接口)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function innerPeoplePeriodStreamRealList(data) {
  return request({
    type: 'device',
    url: 'inner/people/period/stream/real/list',
    method: 'post',
    data
  })
}

/**
 * 人流量-获取今日人流量按小时统计(内部接口)（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function innerPeopleStreamHourStatisticList(data) {
  return request({
    type: 'device',
    url: 'inner/people/stream/hour/statistic/list',
    method: 'post',
    data
  })
}

/**
 * 客流量-获取今日人流量按小时统计（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function innerPeopleStreamPerHourList(data) {
  return request({
    type: 'device',
    url: 'inner/people/stream/per/hour/list',
    method: 'post',
    data
  })
}

/**
 * 人流量-获取实时人流量(内部接口)（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function innerPeopleStreamRealList(data) {
  return request({
    type: 'device',
    url: 'inner/people/stream/real/list',
    method: 'post',
    data
  })
}

/**
 * 修改摄像头状态(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcCameraConfigInfoUpdate(data) {
  return request({
    type: 'device',
    url: 'pc/camera/config/info/update',
    method: 'post',
    data
  })
}

/**
 * 人流量-食堂承载度、实时人数、预测（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peopleBearingCapacityDeptList(data) {
  return request({
    type: 'device',
    url: 'people/bearing/capacity/dept/list',
    method: 'post',
    data
  })
}

/**
 * 人流量-获取时段实时人流量（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peoplePeriodStreamRealList(data) {
  return request({
    type: 'device',
    url: 'people/period/stream/real/list',
    method: 'post',
    data
  })
}

/**
 * 人流量-获取今日人流量按小时统计（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peopleStreamHourStatisticList(data) {
  return request({
    type: 'device',
    url: 'people/stream/hour/statistic/list',
    method: 'post',
    data
  })
}

/**
 * 人流量-获取今日人流量按小时统计(食堂级)（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peopleStreamHourStatisticSingleDeptList(data) {
  return request({
    type: 'device',
    url: 'people/stream/hour/statistic/single/dept/list',
    method: 'post',
    data
  })
}

/**
 * 客流量-获取今日人流量按小时统计（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peopleStreamPerHourList(data) {
  return request({
    type: 'device',
    url: 'people/stream/per/hour/list',
    method: 'post',
    data
  })
}

/**
 * 人流量-获取实时人流量（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peopleStreamRealList(data) {
  return request({
    type: 'device',
    url: 'people/stream/real/list',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心 大数据分析 人流量统计 24小时图标（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peopleStreamRealStatistic24hourGet(data) {
  return request({
    type: 'device',
    url: 'people/stream/real/statistic/24Hour/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心 大数据分析 食安大数据分析 日均人流统计趋势（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peopleStreamRealStatisticAnalyseDayaverageGet(data) {
  return request({
    type: 'device',
    url: 'people/stream/real/statistic/analyse/dayaverage/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心 大数据分析 食安大数据分析 人流量分析（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peopleStreamRealStatisticAnalyseGet(data) {
  return request({
    type: 'device',
    url: 'people/stream/real/statistic/analyse/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心 大数据分析 人流量统计 密度排行（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peopleStreamRealStatisticDensityRankGet(data) {
  return request({
    type: 'device',
    url: 'people/stream/real/statistic/density/rank/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心 大数据分析 人流量统计 导出全部（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peopleStreamRealStatisticExport(data) {
  return request({
    type: 'device',
    url: 'people/stream/real/statistic/export',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心 大数据分析 人流量统计 左侧统计信息（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peopleStreamRealStatisticGet(data) {
  return request({
    type: 'device',
    url: 'people/stream/real/statistic/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心 大数据分析 人流量统计 选择导出（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peopleStreamRealStatisticOptionExport(data) {
  return request({
    type: 'device',
    url: 'people/stream/real/statistic/option/export',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心 大数据分析 人流量统计 分页列表（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peopleStreamRealStatisticPageList(data) {
  return request({
    type: 'device',
    url: 'people/stream/real/statistic/page/list',
    method: 'post',
    data
  })
}

/**
 * 扫描枪测试（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function scan(data) {
  return request({
    type: 'device',
    url: 'scan',
    method: 'post',
    data
  })
}

/**
 * 人流量-预测下一个小时的客流量(食堂级)（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function v1ForecastNextHourDeptGet(data) {
  return request({
    type: 'device',
    url: 'v1/forecast/next/hour/dept/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Camera.js